import { createSaga } from './saga-helpers';

import * as Api from '../api/goals-api';

const watchGetGoals = createSaga({
    type: 'GOALS_FETCH',
    fn: Api.fetchGoals,
    args: action => [action.payload],
    successPayload: ({ data, hasMore } = {}, action) => ({
        items: data,
        hasMore,
        ...action.payload
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        ...action.payload
    })
});

const watchCreateGoal = createSaga({
    type: 'GOAL_CREATE',
    fn: Api.createGoal,
    args: action => [action.payload.goal],
    successPayload: ({ id: goalId, progress, source }, action) => ({
        goalId,
        progress,
        source,
        fragment: action.payload.goal
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        fragment: action.payload.goal
    })
});

const watchGetGoal = createSaga({
    type: 'GOAL_FETCH',
    fn: Api.fetchGoal,
    args: action => [action.payload.goalId],
    successPayload: goal => ({ goal }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        goalId: action.payload.goalId
    })
});

const watchUpdateGoal = createSaga({
    type: 'GOAL_UPDATE',
    fn: Api.updateGoal,
    args: action => [action.payload.goalId, action.payload.goalProps],
    successPayload: goal => ({ goal })
});

const watchAssignUsers = createSaga({
    type: 'GOAL_ASSIGN',
    fn: Api.assignUsers,
    args: action => [action.payload.goalId, action.payload.users]
});

const watchUnassignUsers = createSaga({
    type: 'GOAL_UNASSIGN',
    fn: Api.unassignUsers,
    args: action => [action.payload.goalId, action.payload.users]
});

const watchTieTasks = createSaga({
    type: 'GOAL_TIE_TASKS',
    fn: Api.tieTasks,
    args: action => [action.payload.goalId, action.payload.taskIds]
});

const watchUntieTasks = createSaga({
    type: 'GOAL_UNTIE_TASKS',
    fn: Api.untieTasks,
    args: action => [action.payload.goalId, action.payload.taskIds]
});

const watchTieMilestones = createSaga({
    type: 'GOAL_TIE_MILESTONES',
    fn: Api.tieMilestones,
    args: action => [action.payload.goalId, action.payload.milestoneIds]
});

const watchUntieMilestones = createSaga({
    type: 'GOAL_UNTIE_MILESTONES',
    fn: Api.untieMilestones,
    args: action => [action.payload.goalId, action.payload.milestoneIds]
});

const watchRemoveGoal = createSaga({
    type: 'GOAL_REMOVE',
    fn: Api.removeGoal,
    args: action => [action.payload.goalId]
});

const sagas = [watchGetGoals, watchCreateGoal, watchGetGoal, watchUpdateGoal, watchAssignUsers, watchUnassignUsers, watchTieTasks, watchUntieTasks, watchTieMilestones, watchUntieMilestones, watchRemoveGoal];

export default sagas;
